import { Drawer } from '@mantine/core';

import classes from './drawer.module.css';

export const DrawerOverride = Drawer.extend({ classNames: classes });
